// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"fe6db663","669":"a62dd490","845":"6a2b73fc"}[chunkId] + ".chunk.js";
};